module.exports = __webpack_public_path__ + "static/media/especialistas_testimonios8.757ccd97.jpeg";